import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {SessionService} from './session.service';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {SendActionFailure, SendActionSuccess} from '../stores/root-store/actions/external-actions.action';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ExternalActionService {

    constructor(
        private sessionService: SessionService,
        private httpService: HttpService
    ) {
    }

    execute(actionId: string) {
        return this.httpService.sendAction(this.sessionService.sessionToken, actionId).pipe(
            map(() => SendActionSuccess({
                actionId
            })),
            catchError((err: HttpErrorResponse) => {
                return of(SendActionFailure({
                    message: err.error?.message
                }));
            })
        )
    }
}
